import React from 'react';
import Spacer from 'ViatoUi/Shared/Layouts/Spacer';

import Selection from './Selection';
import Summary from './Summary';

const Step3 = () => {
	return (
		<>
			<Summary />
			<Spacer height='xxl' />
			<Selection />
		</>
	);
};

export default Step3;
